import '../Roboto-Regular-normal.js'

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

const headerIndexes = {
  nrFaktury: 6,
  nabywca: 12,
  nabywcaMiasto: 14,
  dataSprzedazy: 22,
  dataWystawienia: 21,
  netto: 27,
  vat: 28,
  brutto: 29
}

export function parseEppFile(text: string) {
  const lines = text
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean)
  const invoicesData: any[] = []

  let currentInvoice: any = null
  let expectContent = false

  lines.forEach((line) => {
    if (line === '[NAGLOWEK]') {
      expectContent = false
      currentInvoice = null
    } else if (line.startsWith('"FS"')) {
      const cols = line
        .split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/)
        .map((col) => col.replace(/^"|"$/g, ''))
      currentInvoice = {
        nrFaktury: cols[headerIndexes.nrFaktury] || '',
        nabywca: cols[headerIndexes.nabywca] || '',
        miasto: cols[headerIndexes.nabywcaMiasto] || '',
        dataSprzedazy: cols[headerIndexes.dataSprzedazy] || '',
        dataWystawienia: cols[headerIndexes.dataWystawienia] || '',
        netto: cols[headerIndexes.netto] || '',
        vat: cols[headerIndexes.vat] || '',
        brutto: cols[headerIndexes.brutto] || '',
        pozycje: []
      }
      invoicesData.push(currentInvoice)
    } else if (line === '[ZAWARTOSC]') {
      expectContent = true
    } else if (expectContent && /^[A-Z],/.test(line) && currentInvoice) {
      const cols = line.split(',')
      currentInvoice.pozycje.push({
        typ: cols[0],
        stawkaVat: cols[1],
        netto: cols[2],
        vat: cols[3],
        brutto: cols[4]
      })
    }
  })

  return invoicesData
}

// Suma według stawek VAT (dla całego zestawienia)
function summaryVatRate(invoicesData: any[]) {
  type VatSummary = {
    netto: number
    vat: number
    brutto: number
  }
  const vatGroups: Record<string, VatSummary> = {}
  const num = (v: string) => parseFloat((v || '0').replace(',', '.')) || 0

  invoicesData.forEach((f) =>
    f.pozycje.forEach((poz: any) => {
      const sv = poz.stawkaVat || '-'
      if (!vatGroups[sv]) vatGroups[sv] = { netto: 0, vat: 0, brutto: 0 }
      vatGroups[sv].netto += num(poz.netto)
      vatGroups[sv].vat += num(poz.vat)
      vatGroups[sv].brutto += num(poz.brutto)
    })
  )

  return Object.entries(vatGroups).map(([stawka, { netto, vat, brutto }]) => ({
    stawka,
    netto: netto.toFixed(2),
    vat: vat.toFixed(2),
    brutto: brutto.toFixed(2)
  }))
}

export function invoicesToPdfDoc(invoicesData: any[], fromDate: string, toDate: string) {
  const doc = new jsPDF({ orientation: 'landscape' })
  doc.setFont('Roboto-Regular', 'normal')

  doc.setFontSize(16)
  doc.text(`Podsumowanie za okres: ${fromDate} - ${toDate}`, 14, 16)
  doc.setFontSize(11)
  doc.setFont('Roboto-Regular', 'normal')

  // Tabela ogólna: tylko nagłówki faktur
  const invoiceHead = [
    [
      'Nr faktury',
      'Nabywca',
      'Miasto',
      'Data sprzedaży',
      'Data wystawienia',
      'Stawka VAT',
      'Netto',
      'VAT',
      'Brutto'
    ]
  ]
  const invoiceBody = invoicesData.map((f) => {
    // Zbiór wszystkich stawek VAT w tej fakturze (z pozycji)
    const vatRates = [
      ...new Set(
        f.pozycje.map((poz: any) => poz.stawkaVat || '').filter(Boolean)
      )
    ]
    return [
      f.nrFaktury,
      f.nabywca,
      f.miasto,
      f.dataSprzedazy,
      f.dataWystawienia,
      vatRates.length ? vatRates.join(', ') : '-',
      f.netto,
      f.vat,
      f.brutto
    ]
  })

  autoTable(doc, {
    startY: 28,
    head: invoiceHead,
    body: invoiceBody,
    styles: {
      font: 'Roboto-Regular',
      fontStyle: 'normal',
      fontSize: 10
    },
    theme: 'grid',
    headStyles: { fillColor: [40, 155, 40] }
  })

  let lastY = (doc as any).lastAutoTable.finalY + 15

  // Podsumowanie według stawki VAT
  doc.setFontSize(13)
  doc.text('Podsumowanie według stawki VAT:', 14, lastY)
  lastY += 4

  const summaryByVatRates = summaryVatRate(invoicesData)
  autoTable(doc, {
    startY: lastY + 2,
    head: [['Stawka VAT', 'Netto', 'VAT', 'Brutto']],
    body: summaryByVatRates.map((row) => [
      row.stawka,
      row.netto,
      row.vat,
      row.brutto
    ]),
    styles: { fontSize: 12, fontStyle: 'bold' },
    headStyles: { fillColor: [80, 180, 80] },
    theme: 'grid'
  })

  return doc
}
